<template>
  <div>
    <div class="overflow-auto">
      <ts-loading-banner :loading="waiting">
        <table id="table-details">
          <thead>
            <tr>
              <th class="ts-whitespace-no-wrap" style="width:200px">
                {{ $t('invoice.feeType') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:200px">
                {{ $t('invoice.feeName') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 140px;">
                {{ $t('invoice.dateFrom') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 140px;">
                {{ $t('invoice.dateTo') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 70px;">
                {{ $t('invoice.qty') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 99px;">
                {{ $t('invoice.fee') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width:90px">
                {{ $t('invoice.discountType') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 94px;">
                {{ $t('invoice.discount') }}
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 81px;">
                {{ $t('invoice.vat') }}(%)
              </th>
              <th class="ts-whitespace-no-wrap" style="width: 120px;">
                {{ $t('invoice.amount') }}
              </th>
              <th class="ts-w-8">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in model.inv_detail_list" :key="index">
              <td valign="top">
                <a-select v-model.number="detail.fee_type_id" style="width: 100%" :options="feeTypesList"
                  @change="fetchFeeSetupDetail(detail)" :disabled="!disableSelect" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_type_id')">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_type_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-select v-model.number="detail.fee_setup_id" style="width:100%" :showSearch="true"
                  :options="feeSetupDetail(detail)" :disabled="!disableSelect" :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                    " optionFilterProp="children" @change="onFeeSetupChange(detail)" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_setup_id')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_setup_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-date-picker placeholder="Date From" valueFormat="DD-MM-YYYY" format="DD-MM-YYYY"
                  v-model="detail.fee_start_date" style="width: 100%" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_start_date')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_start_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-date-picker placeholder="Date To" valueFormat="DD-MM-YYYY" format="DD-MM-YYYY"
                  v-model="detail.fee_end_date" style="width: 100%" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_end_date')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_end_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <input type="number" min="1" class="form-control" v-model="detail.quantity" @input="calculate"
                  :readonly="![5,6,7].includes(detail.fee_type_id)" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.quantity')">
                  {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                </div>
              </td>
              <td valign="top">
                <input type="number" step="any" class="form-control" v-model="detail.fee_amount" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_amount')">
                  {{ errors.first('inv_detail_list.' + index + '.fee_amount') }}
                </div>
              </td>
              <td valign="top">
                <a-select v-model="detail.discount_type" style="width: 100%" :options="[
                  { value: '$', label: '$' },
                  { value: '%', label: '%' }
                ]" @change="calculate" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.discount_type')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.discount_type')
                  }}
                </div>
              </td>
              <td valign="top">
                <input v-model="detail.discount_rate" type="number" class="form-control" @input="calculate" />
              </td>
              <td valign="top">
                <input type="number" class="form-control" v-model="detail.vat_rate" @input="calculate" />
              </td>
              <td valign="top">
                <a-input :value="withDefaultCurrency(detail.amount_include_vat)" disabled></a-input>
              </td>
              <td class="ts-justify-center" valign="top">
                <a href="#"
                  class="ts-w-8 ts-h-8 ts-flex ts-items-center ts-justify-center ts-bg-red-100 ts-text-red-500 ts-rounded-full hover:ts-text-red-500 hover:ts-no-underline"
                  @click.prevent="removeRow(detail)">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr>
              <td colspan="10">
                <button
                  class="ts-w-full ts-py-2 ts-bg-blue-100 ts-rounded-md focus:ts-outline-none hover:ts-bg-blue-300 hover:ts-text-white ts-duration-150"
                  @click.prevent="addRow">
                  {{ $t('invoice.moreItem') }}
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="11">
                <div class="ts-border-b ts-w-full"></div>
              </td>
            </tr>
            <tr class="bb">
              <td colspan="3" valign="top">
                <textarea v-model="model.remark" rows="4" :placeholder="$t('invoice.remark')"
                  class="form-control"></textarea>
              </td>
              <td colspan="4" valign="top">
                <div class="ts-border ts-p-2 ts-rounded ts-space-y-2" style="min-height: 300px;">
                  <div class="ts-flex ts-space-x-2 ts-items-center">
                    <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.fxRate') }}
                    </p>
                    <p v-for="(ex, index) in exchangeRate">
                      {{ ex.currency_code }} : {{ ex.exchange_rate }}
                    </p>
                  </div>
                  <div class="ts-grid ts-grid-cols-2 ts-gap-2 ts-border ts-border-dashed ts-rounded-md ts-p-2">
                    <p v-for="(ex, index) in exchangeRate">
                      {{ ex.currency_code }}: {{ ((model.total_amount - model.discounted_amount) > 0 ?
                        (model.total_amount - model.discounted_amount) / ex.rate_to_default : 0).toFixed(2) }}
                    </p>
                  </div>
                  <div class="ts-space-y-2">
                    <div v-for="(payment, id) in model.received_payment"
                      class="ts-border ts-border-dashed ts-px-1 ts-rounded">
                      <div class="ts-font-semibold ts-py-2 ts-flex ts-items-center ts-justify-between ts-space-x-2">
                        <div class="ts-flex ts-items-center ts-space-x-2">
                          <p class="ts-bg-blue-100 ts-text-blue-500 ts-px-2 ts-rounded">{{ findPaymentNameById(id) }}
                            <span class="ts-text-red-600">*</span>
                          </p>
                          <div class="ts-whitespace-no-wrap">
                            <a-checkbox v-for="(c, index) in currency" :key="index"
                              :checked="currencyCheck(id, c.currency_id)"
                              @change="e => onCurrencyChange(e, c, { id, payment })">
                              {{ c.currency_code }}
                            </a-checkbox>
                          </div>
                        </div>
                        <button @click="removePaymentMethod(id)"
                          class="ts-bg-red-100 ts-h-6 ts-w-6 ts-flex ts-items-center ts-justify-center ts-rounded-full hover:ts-bg-red-500 hover:ts-text-white ts-duration-150 focus:ts-outline-none">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                      <div class="ts-pl-3">
                        <div v-if="parseInt(id) !== 1" class="ts-grid ts-grid-cols-2 ts-gap-2">
                          <div>
                            <a-select v-model="payment.bank_id" :options="bank" :placeholder="$t('invoice.selecteBank')"
                              class="ts-w-full" @change="onBankChange(payment)">
                            </a-select>
                            <div v-if="errors.has(`received_payment.${id}.bank_id`)" class="ts-text-red-500">
                              {{ errors.first(`received_payment.${id}.bank_id`) }}
                            </div>
                          </div>
                          <div>
                            <a-select v-model="payment.account_id" :options="accountById(payment.bank_id)"
                              :placeholder="$t('invoice.selecteAccount')" class="ts-w-full"></a-select>
                            <div v-if="errors.has(`received_payment.${id}.account_id`)" class="ts-text-red-500">
                              {{ errors.first(`received_payment.${id}.account_id`) }}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-for="(p, pindex) in payment.payments"
                            class="ts-py-2 ts-flex ts-items-center ts-space-x-2">
                            <p>{{ currencyNameById(p.currency_original_id) }}</p>
                            <div class="ts-space-y-1 ts-w-full">
                              <input v-model.number="p.amount_original" type="number" step="any"
                                class="ts-border ts-w-full ts-px-3 ts-py-1 focus:ts-outline-none ts-rounded"
                                :ref="`input_${id}_${p.currency_original_id}`" @input="paymentInputChange(id, p)" />
                              <div v-if="errors.has(`received_payment.${id}.payments.${pindex}.amount_original`)"
                                class="ts-text-red-500">
                                {{ errors.first(`received_payment.${id}.payments.${pindex}.amount_original`) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="errors.has('received_payment')" class="ts-text-red-500">
                      {{ errors.first('received_payment') }}
                    </div>
                  </div>

                  <a-dropdown placement="bottomCenter">
                    <button
                      class="ts-bg-blue-200 ts-text-blue-500 ts-rounded-md ts-px-3 ts-py-2 ts-w-full hover:ts-bg-blue-300 hover:ts-text-white ts-duration-150 focus:ts-outline-none">
                      {{ $t('invoice.morePaymentMethod') }}
                    </button>
                    <a-menu slot="overlay">
                      <a-menu-item v-for="(p, index) in paymentMethodsList" :key="index"
                        @click="addPaymentMethod(p.id)">{{ p.label }}</a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </td>
              <td colspan="3" valign="top">
                <div class="ts-p-2 ts-border ts-rounded ts-space-y-2">
                  <div class="ts-space-y-1">
                    <p class="ts-bg-red-100 ts-text-red-500 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.subTotal') }}</p>
                    <a-input :value="withDefaultCurrency(model.total_amount)" disabled></a-input>
                    <div class="validate" v-if="errors.has('total_amount')">
                      {{ errors.first('total_amount') }}
                    </div>
                  </div>

                  <div class="ts-space-y-1">
                    <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.discount') }}</p>
                    <div class="ts-flex ts-items-center ts-border ts-rounded ts-w-full ts-p-1">
                      <select v-model="model.discount_type" @change="calculate"
                        class="focus:ts-outline-none ts-px-3 ts-rounded">
                        <option value="%">%</option>
                        <option value="$">$</option>
                      </select>
                      <input v-model.number="model.discount_value" type="number" step="any"
                        class="ts-w-full ts-py-1 focus:ts-outline-none ts-ml-2" @input="calculate" />
                    </div>
                  </div>
                  <div class="ts-space-y-1">
                    <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.grandTotal') }}</p>
                    <a-input :value="withDefaultCurrency(model.total_amount - model.discounted_amount)"
                      disabled></a-input>
                  </div>
                  <div class="ts-space-y-1">
                    <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.dueAmount') }}</p>
                    <a-input :value="withDefaultCurrency(model.amount_due)" disabled></a-input>
                    <div class="validate" v-if="errors.has('amount_due')">
                      {{ errors.first('amount_due') }}
                    </div>
                  </div>
                  <div class="ts-space-y-1">
                    <p class="ts-bg-gray-100 ts-text-gray-600 ts-py-1 ts-px-2 ts-rounded" style="width: fit-content;">{{
                      $t('invoice.nextPaymentDate') }}</p>
                    <a-date-picker :disabled="allowPickNewPaymentDate" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                      v-model="model.next_payment_date" style="width: 100%" />
                    <div class="validate" v-if="errors.has('next_payment_date')">
                      {{ errors.first('next_payment_date') }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
/**
 *  as request hidden qty column by bong borin
 *  calculate on start date to end date
 *
 */

import { Errors } from 'form-backend-validation'
import { clone, round, sumBy } from 'lodash'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'manualDetailCreate',
  props: [
    'value',
    'validate',
    'preDetails',
    'loadingPreInv',
    'bank',
    'currency',
    'exchangeRate'
  ],
  data() {
    return {
      duration_in_month: null,
      model: {},
      newRow: {
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        fee_start_date: null,
        fee_end_date: null,
        payment_term_id: null,
        duration_in_month: null,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        discount_reason: null,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        ac_term_id: null,
        grade_id: null,
        shift_id: null,
        disabled: false, // just a variable to lock item from fee group
        duration_in_month_filter: null,
        pro_type_id: null // just a variable to lock item from fee group
      },
      exchange_rate: 0,
      exchanges: [],
      waiting: false,
      feeTypes: [],
      feeSetups: [],
      feeItemDetails: [],
      errors: new Errors(),
      promoTypes: [],
      paymentMethods: []
    }
  },
  created() {
    this.model = this.value
    this.addRow()
    this.fetchFeeType()
    this.exchangeRates()
    // this.fetchPromotion()   //user only asean
    this.getPaymentMethod()
  },
  computed: {
    ...mapState('invoice', [
      'room_type_id',
      'defaultCreditDay',
      'paymentTerms'
    ]),
    disableSelect() {
      return this.model.student_id != null
    },
    allowPickNewPaymentDate() {
      return !this.model.amount_due > 0
    },
    concatValue() {
      return this.model.student_id + this.model.grade_id + this.model.ac_term_id
    },
    feeSetupDetail: vm => row => {
      if (row) {
        let feeSetup = vm.feeSetups.filter(
          f => f.fee_type_id == row.fee_type_id
        )
        return feeSetup
      }

      return []
    },
    feeTypesList() {
      return this.feeTypes.filter(f => f.hidden === false)
    },
    withDefaultCurrency: vm => value => {
      const defCurrency = vm.defaultCurrecy
      if (defCurrency) {
        return `${defCurrency.currency_code} ${value.toLocaleString('en-US')}`
      }
      return value;
    },
    defaultCurrency() {
      return this.currency.find(c => c.is_default)
    },
    findCurrencyBySign(sign) {
      return this.currency.find(c => c.currency_symbol)
    },
    currencyNameById: vm => (id) => {
      const curr = vm.currency.find(c => c.currency_id === id)
      if (curr) {
        return curr.currency_code
      }
      return undefined
    },
    paymentMethodsList() {
      return this.paymentMethods.filter(p => !Object.keys(this.model.received_payment).map(Number).includes(p.id))
    },
    findPaymentNameById: vm => (id) => {
      const findPayment = vm.paymentMethods.find(p => p.id == id)
      if (findPayment) {
        return findPayment.label
      }
      return ''
    },
    currencyCheck: vm => (id, currencyId) => {
      const itemPayment = vm.model.received_payment[id]
      if (itemPayment.payments) {
        return itemPayment.payments.find(ip => ip.currency_original_id == currencyId) !== undefined
      }
      return false;
    },
    findExchangeRateById: vm => id => {
      return vm.exchangeRate.find(ex => ex.target_currency_id === id)
    },
    accountById: vm => (id) => {
      const findBank = vm.bank.find(b => b.value === id)
      if (findBank) {
        return findBank.accounts.map(el => ({
          value: el.account_id,
          label: `${el.account_name}`
        }))
      }
    }
  },
  methods: {
    ...mapActions('invoice', [
      'getFeeType',
      'getSubscriptionService',
      'getFeeSetupDetail',
      'feeGroupDetail',
      'getPaymentTerm',
      'getFormViewModel',
      'getExchangeRate',
      'invoiceFormView'
    ]),
    addRow() {
      this.model.inv_detail_list.push(clone(this.newRow))
    },
    removeRow(row) {
      this.model.inv_detail_list.splice(
        this.model.inv_detail_list.indexOf(row),
        1
      )
      var findFeeGroupItem = this.model.inv_detail_list.filter(
        d => d.disabled == true
      )
      if (
        this.feeItemDetails[row.fee_type_id] != undefined &&
        row.disabled == true
      ) {
        delete this.feeItemDetails[row.fee_type_id]
      }
      if (!findFeeGroupItem.length > 0) {
        this.model.fee_group_id = null // set fee group to null when deleted all it's item
      }

      this.calculate()
    },
    // fetch fee type when component created
    async fetchFeeType() {
      this.waiting = true
      await this.getPaymentTerm()
      this.invoiceFormView({
        fnName: 'feeType'
      })
        .then(response => {
          this.feeTypes = response.data.feeType.map(el => ({
            value: el.fee_type_id,
            label: el.fee_type_name,
            hidden: false
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // fetch fee setup detail when fee type change
    async fetchFeeSetupDetail(row, waiting = 0) {
      if (!this.feeItemDetails.hasOwnProperty(row.fee_type_id)) {
        this.waiting = !waiting ? true : ''
        let response = await this.getFeeSetupDetail({
          student_id: this.model.student_id,
          ac_term_id: this.model.ac_term_id,
          grade_id: this.model.grade_id,
          fee_type_id: row.fee_type_id,
          invoice_date: this.model.inv_date,
          room_type_id: this.room_type_id,
          inv_id: this.model.pre_inv_id
        })
        this.waiting = !waiting ? false : ''
        if (waiting == 0) {
          this.clearRow(row)
        }
        this.feeItemDetails = Object.assign(
          {},
          this.feeItemDetails,
          response.data
        ) // store temporary fee item detail when change fee type
        this.pushNewValueFeeSetup(Object.values(response.data).flat())

        // remove tuition fee and item detail, if get empty array from function
        if (response.data.length === 0) {
          const ftype = this.feeTypes.find(f => f.value === row.fee_type_id)
          if (ftype !== undefined) {
            ftype.hidden = true
            this.model.inv_detail_list = this.model.inv_detail_list.filter(
              fs => fs.fee_type_id !== row.fee_type_id
            )
            // Remove items with matching fee_type_id from feeSetups
            this.feeSetups = this.feeSetups.filter(
              fs => fs.fee_type_id !== row.fee_type_id
            )
            delete this.feeItemDetails[row.fee_type_id]
            this.calculate()
          }
        }
      }
    },
    // set value to each column in details
    onFeeSetupChange(item) {
      const itemDetails = this.feeItemDetails[item.fee_type_id]
      if (itemDetails !== undefined) {
        itemDetails
          .filter(f => f.fee_setup_id == item.fee_setup_id)
          .forEach(el => {
            if (!this.model.remark) {
              this.model.remark = el.discount_remark
            }
            item.fee_description = el.fee_name // description is a fee name
            item.quantity = item.quantity || 1
            item.fee_start_date = el.fee_start_date
              ? moment(el.fee_start_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
              : null
            item.fee_end_date = el.fee_end_date
              ? moment(el.fee_end_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
              : null
            item.payment_term_id = el.payment_term_id
            item.duration_in_month = el.duration_in_month
            item.fee_amount = el.fee_amount
            item.discount_rate = el.discount_rate
            item.discount_reason = el.discount_remark
              ? el.discount_remark
              : null
            item.ac_term_id = el.ac_term_id
            item.grade_id = el.grade_id
            item.shift_id = el.shift_id

            if (item.fee_type_id == 1) {
              // set promotion type id only tuition fee
              item.pro_type_id = el.pro_type_id
                ? parseInt(el.pro_type_id)
                : null

              // just show expired date to user if have promotion
              this.model.promtion_expired_date = el.promotion_expiry_date
                ? moment(el.promotion_expiry_date, 'DD-MM-YYYY')
                : null
            }
          })

        this.calculate()
      }
    },
    // push a new value to be select on fee name
    pushNewValueFeeSetup(value) {
      value
        .filter(v => v.fee_setup_id > 0)
        .forEach(el => {
          if (
            !this.feeSetups.filter(f => f.value == el.fee_setup_id).length > 0
          ) {
            this.feeSetups.push({
              fee_type_id: el.fee_type_id,
              value: el.fee_setup_id,
              label: el.fee_name,
              duration_in_month: parseInt(el.duration_in_month)
            })
          }
        })
    },
    // fetch subscription service by student
    async fetchSubscriptionService() {
      this.waiting = true
      await this.getSubscriptionService({
        student_id: this.model.student_id,
        ac_term_id: this.model.ac_term_id,
        grade_id: this.model.grade_id,
        inv_date: this.model.inv_date,
        room_type_id: this.room_type_id
      })
        .then(response => {
          this.pushNewValueFeeSetup(Object.values(response).flat())
          this.createRecordFromSubscription(Object.values(response).flat())
        })
        .catch(error => {
          this.$toasted.error(
            error.message + Object.values(error.errors).toString()
          )
        })
    },
    // create item list detail after fetch subscription service
    async createRecordFromSubscription(data) {
      this.model.inv_detail_list = []
      this.waiting = true
      await Promise.all(
        data.map(async el => {
          if (el.fee_setup_id) {
            var row = clone(this.newRow)
            row.fee_type_id = el.fee_type_id
            row.fee_amount = parseFloat(el.fee_amount)
            row.fee_setup_id = el.fee_setup_id
            const rowDetail = this.model.inv_detail_list.filter(
              d => d.fee_type_id == row.fee_type_id
            ).length

            if (rowDetail == 0) {
              if (
                this.model.inv_detail_list.filter(
                  f => f.fee_type_id == el.fee_type_id
                ).length == 0
              ) {
                this.model.inv_detail_list.push(row)
                await this.fetchFeeSetupDetail(row, 1)
                this.onFeeSetupChange(row)
              }
            }
          }
        })
      )
      this.waiting = false
    },
    // fetch fee group detail when clik on fee group list
    fetchFeeGroupDetail() {
      this.waiting = true
      this.feeGroupDetail({
        student_id: this.model.student_id,
        ac_term_id: this.model.ac_term_id,
        fee_group_id: this.model.fee_group_id,
        grade_id: this.model.grade_id,
        inv_date: this.model.inv_date
      })
        .then(response => {
          this.createRecordDetailFromFeeGroup(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // create record detail when user click on free group
    createRecordDetailFromFeeGroup(details) {
      this.model.pre_inv_id = 0
      this.model.inv_detail_list = []
      // push a new value to be select on fee name
      this.pushNewValueFeeSetup(Object.values(details).flat())
      // create a temporary fee setup detail items
      this.feeItemDetails = Object.assign({}, details)
      // set new value to each columns in row details
      Object.values(details)
        .flat()
        .map(el => {
          var row = clone(this.newRow)
          row.fee_type_id = el.fee_type_id
          row.fee_setup_id = el.fee_setup_id
          row.disabled = true
          this.model.inv_detail_list.push(row)
          this.onFeeSetupChange(row)
        })
    },
    async createRecordDetailFromPreInvoice(data) {
      this.model.fee_group_id = null
      this.model.inv_detail_list = []
      this.feeTypes.forEach(el => (el.hidden = false))
      // push a new value to be select on fee name
      this.feeSetups = []

      //re-create a termporary fee setup detail items
      this.feeItemDetails = {}

      // set new value to each columns in row details
      await Promise.all(
        Object.values(data)
          .flat()
          .map(async el => {
            var row = clone(this.newRow)
            row.fee_type_id = el.fee_type_id
            row.fee_setup_id = el.fee_setup_id
            row.discount_type = el.discount_type
            row.quantity = el.quantity
            row.disabled = true
            this.model.inv_detail_list.push(row)
            await this.fetchFeeSetupDetail(row, 1)
            this.onFeeSetupChange(row)
            row.discount_type = el.discount_type
            row.discount_rate = el.discount_rate
            this.calculate()
          })
      )
      this.waiting = false
    },
    // calculate invoice amount
    calculate() {
      var price = 0
      if (this.model.inv_detail_list.length > 0) {
        this.model.inv_detail_list.forEach(detail => {
          detail.quantity = detail.quantity ? detail.quantity : 1
          price = detail.fee_amount ? detail.fee_amount * detail.quantity : 0
          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? price * round(detail.discount_rate / 100, 4)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = detail.discount_rate
          }
          detail.total_amount = price - detail.discount_amount
          detail.vat_amount = detail.vat_rate
            ? detail.total_amount * round(detail.vat_rate / 100, 4)
            : 0
          detail.amount_include_vat = round(
            detail.total_amount + detail.vat_amount,
            2
          )
        })

        let sumAmountIncludeVat = sumBy(
          this.model.inv_detail_list,
          'amount_include_vat'
        )
        this.model.total_amount = round(sumAmountIncludeVat, 2)

        if (this.model.discount_type == '%') {
          this.model.discounted_amount = this.model.total_amount
            ? this.model.total_amount *
            round(this.model.discount_value / 100, 4)
            : 0
        } else if (this.model.discount_type == '$') {
          this.model.discounted_amount = this.model.discount_value
        } else {
          this.model.discounted_amount = 0
        }

        this.paymentReceiveInput()
      }
    },
    // set each row to default by fee type change
    clearRow(row) {
      row.fee_setup_id = null
      row.fee_description = ''
      row.quantity = 1
      row.fee_start_date = null
      row.fee_end_date = null
      row.payment_term_id = null
      row.duration_in_month = null
      row.fee_amount = 0
      row.discount_rate = 0
      row.discount_amount = 0
      row.discount_reason = null
      row.total_amount = 0
      row.vat_rate = 0
      row.vat_amount = 0
      row.amount_include_vat = 0
      row.ac_term_id = null
      row.grade_id = null
      row.shift_id = null
      row.pro_type_id = null
    },
    exchangeRates() {
      this.getExchangeRate().then(response => {
        this.model.fx_rate = response.exchange_rate
      })
    },
    getPaymentMethod() {
      this.invoiceFormView({
        fnName: 'paymentMethod'
      })
        .then(({ data }) => {
          this.paymentMethods = data.paymentMethod
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    paymentInputChange(id, payment) {
      /**
       * Cash payment
       */
      if (id == 1 && payment.currency_original_id === this.defaultCurrency.currency_id) {
        const cashPayment = this.model.received_payment[id]
        if (cashPayment) {
          const defaultInput = cashPayment.payments.find(c => c.currency_original_id === this.defaultCurrency.currency_id)
          if (defaultInput) {
            const anotherCurrency = cashPayment.payments
              .filter(c => c.currency_original_id !== this.defaultCurrency.currency_id)

            const amount = (this.model.total_amount - this.model.discounted_amount - defaultInput.amount_original) / anotherCurrency.length

            if (anotherCurrency.length) {
              anotherCurrency.forEach(c => {
                c.amount_original = round(amount * (1 / c.rate_to_base), 2)
              })
            }
          }
        }
      }

      this.$nextTick(() => this.paymentReceiveInput())
    },
    paymentReceiveInput() {
      const paymentReceive = Object.values(this.model.received_payment)
      const payment = paymentReceive.flatMap(el => el.payments)
      if (payment) {
        const amount = sumBy(payment, (o) => (o.amount_original || 0) * o.rate_to_base)
        this.model.amount_paid = amount
        this.model.amount_due = round(this.model.total_amount - this.model.discounted_amount - (amount || 0), 2)
      } else {
        this.model.amount_paid = 0
        this.model.amount_due = this.model.total_amount - this.model.discounted_amount
      }

    },
    addPaymentMethod(id) {
      // Input validation
      if (!id) {
        throw new Error('Payment method ID is required');
      }

      if (!this.defaultCurrency) {
        this.$toasted.error('Please set default currency first!')
        return
      }

      // Initialize received_payment if it doesn't exist
      if (!this.model.received_payment) {
        this.model.received_payment = {};
      }

      // Use spread operator for cleaner object assignment
      this.model.received_payment = {
        ...this.model.received_payment,
        [id]: {
          bank_id: undefined,
          account_id: undefined,
          payments: [
            {
              amount_original: undefined,
              currency_original_id: this.defaultCurrency.currency_id,
              base_currency: this.defaultCurrency.currency_id,
              rate_to_base: 1
            }
          ]
        }
      };
      this.focusInputElement(id, this.defaultCurrency.currency_id)
      this.loadAmountDefault()
    },
    removePaymentMethod(id) {
      if (this.$delete) {
        this.$delete(this.model.received_payment, id);
      } else {
        // Fallback: Replace entire object to trigger reactivity
        const { [id]: removed, ...remaining } = this.model.received_payment;
        this.model.received_payment = remaining;
      }

      this.paymentReceiveInput()
    },
    onCurrencyChange(event, currency, { id, payment }) {
      const isChecked = event.target.checked
      const existing = payment.payments.find(p => p.currency_original_id === currency.currency_id)
      const exchange = this.findExchangeRateById(currency.currency_id)
      if (currency.currency_id !== this.defaultCurrency.currency_id && exchange === undefined) {
        this.$toasted.error(`Please set up exchange rate for ${currency.currency_code} first!`)
        return
      }
      if (isChecked) {
        if (!existing) {
          payment.payments.push({
            amount_original: undefined,
            currency_original_id: currency.currency_id,
            base_currency: this.defaultCurrency.currency_id,
            rate_to_base: currency.currency_id !== this.defaultCurrency.currency_id ? exchange.rate_to_default : 1
          })
          this.focusInputElement(id, currency.currency_id)
          if (currency.currency_id === this.defaultCurrency.currency_id) {
            this.loadAmountDefault()
          }
        }
        this.clearOtherCurrencyInput(id, payment)
        return
      }

      if (existing) {
        payment.payments.splice(payment.payments.indexOf(existing), 1)
        this.paymentReceiveInput()
      }
      if (currency.currency_id === this.defaultCurrency.currency_id) {
        this.loadAmountDefault()
      }

      this.clearOtherCurrencyInput(id, payment)
    },
    focusInputElement(id, currency_id) {
      this.$nextTick(() => {
        const refKey = `input_${id}_${currency_id}`
        const inputElement = this.$refs[refKey]
        if (inputElement) {
          if (Array.isArray(inputElement)) {
            if (inputElement.length) {
              inputElement[0].focus()
            }
          }
        }
      })
    },
    loadAmountDefault() {
      if (Object.keys(this.model.received_payment).length === 1) {
        Object.keys(this.model.received_payment).forEach(method => {
          const payment = this.model.received_payment[method]
          if (payment.payments[0]) {
            const defaultCurrency = payment.payments.find(c => c.currency_original_id === this.defaultCurrency.currency_id)
            if (defaultCurrency) {
              defaultCurrency.amount_original = this.model.total_amount - this.model.discounted_amount
              this.model.amount_paid = this.model.total_amount - this.model.discounted_amount
              this.model.amount_due = 0
            }
          }
        })
      }
    },
    clearOtherCurrencyInput(methodId, payment) {
      if (methodId == 1) {
        if (Object.keys(this.model.received_payment).length > 0) {
          Object.keys(this.model.received_payment).forEach(method => {
            const payment = this.model.received_payment[method]
            if (payment) {
              payment.payments.forEach(el => {
                el.amount_original = undefined
              })
            }
          })
        }
      }
      this.focusInputElement(methodId, this.defaultCurrency.currency_id)
    },
    onBankChange(payment) {
      payment.account_id = undefined
      const findBank = this.bank.find(b => b.value === payment.bank_id)
      if (findBank) {
        const account = findBank.accounts
        if (account.length === 1) {
          payment.account_id = account[0].account_id
        }
      }
    }
  },
  watch: {
    // watch sub program because some student the same id but difference acps
    'model.acps_id': function () {
      this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
      this.feeSetups = [] // clear this because fee setup difference base on acps or term
    },
    loadingPreInv: function (value) {
      if (value) {
        this.waiting = value
      }
    },
    'model.student_id': function (id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        this.model.remark = null
        // this.fetchSubscriptionService()
      }
      this.feeTypes.forEach(el => (el.hidden = false))
    },
    'model.ac_term_id': function (id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.feeSetups = [] // clear this becasue fee setup may difference by grade
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        // this.fetchSubscriptionService()
      }
    },
    'model.grade_id': function (id) {
      if (id && this.model.pre_inv_id == 0) {
        this.feeItemDetails = [] // clear this if student change cuz it can be other fee setup difference
        this.feeSetups = [] // clear this becasue fee setup may difference by grade
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_paid_khr = 0
        this.model.due_amount = 0
        this.model.remark = null
      }
    },
    'model.fee_group_id': function (id) {
      if (id) {
        this.feeSetups = []
        this.fetchFeeGroupDetail()
      }
    },
    'model.inv_detail_list': function (values) {
      if (!values.length > 0 && this.model.pre_inv_id == 0) {
        // clear this after created record successfully
        this.feeItemDetails = []
      }
    },
    concatValue: function (value) {
      if (value && !this.model.pre_inv_id) {
        this.fetchSubscriptionService()
      }
    },
    preDetails: {
      handler(data) {
        if (Object.values(data).length > 0) {
          this.createRecordDetailFromPreInvoice(data)
        }
      },
      deep: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}

#table-details {
  width: 100%;
}

#table-details>thead>tr>th {
  padding: 8px 6px;
  background: #f2f3f4;
}

#table-details>tbody>tr>td {
  padding: 5px 4px;
  font-size: 12px !important;
}

.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
